import dayjsTZ from "../../../utils/dayjs";

const getDate = (date, format) =>
  !!date ? dayjsTZ(date).format(format) : null;

const getWeekDay = (date) =>
  !!date ? dayjsTZ(date).locale("sq").format("dddd") : "";

export const colDefs = ({ dayTypes = {} }) => [
  {
    headerName: "Clocking Id",
    field: "clockingId",
    hide: true,
  },
  {
    headerName: "Fillimi",
    field: "fillim_turni",
    flex: 3,
    mobile: true,
    filter: "agTextColumnFilter",
    format: "HH:mm",
    isExported: true,
    valueGetter: ({ data = {} }) => getDate(data.fillim_turni, "HH:mm"),
    cellRenderer: ({ data = {} }) => getDate(data.fillim_turni, "HH:mm"),
  },
  {
    headerName: "Mbarimi",
    field: "mbarim_turni",
    flex: 3,
    mobile: true,
    filter: "agTextColumnFilter",
    format: "HH:mm",
    isExported: true,
    valueGetter: ({ data = {} }) => getDate(data.mbarim_turni, "HH:mm"),
    cellRenderer: ({ data = {} }) =>
      !!data.mbarim_turni ? (
        dayjsTZ(data.mbarim_turni).format("HH:mm")
      ) : (
        <strong style={{ color: "red" }}>I pacaktuar</strong>
      ),
  },
  {
    headerName: "Data e turnit",
    field: "clockInDate",
    flex: 3,
    filter: "agTextColumnFilter",
    mobile: true,
    isExported: true,
    format: "DD/MM/YYYY",
    isCollapseTitle: true,
    valueGetter: ({ data }) => data?.clockInDate || null,
    valueFormatter: ({ value }) => getDate(value, "DD/MM/YYYY") || "",
    cellRenderer: ({ data }) => getDate(data?.clockInDate, "DD/MM/YYYY"),
    comparator: (a, b) => (a || 0) - (b || 0),
  },
  {
    headerName: "Dita",
    field: "weekDay",
    flex: 2,
    mobile: true,
    isExported: true,
    filter: "agSetColumnFilter",
    valueGetter: ({ data }) => data?.weekDay || getWeekDay(data?.clockInDate),
    cellRenderer: ({ data }) => data?.weekDay || getWeekDay(data?.clockInDate),
    comparator: (_a, _b, nodeA, nodeB) =>
      (nodeA?.data?.clockInDate || 0) - (nodeB?.data?.clockInDate || 0),
  },
  {
    headerName: "Krijuar në",
    field: "createdAt",
    flex: 3,
    filter: "agTextColumnFilter",
    mobile: true,
    isExported: true,
    format: "DD/MM/YYYY",
    valueGetter: ({ data }) => data?.createdAt || null,
    valueFormatter: ({ value }) => getDate(value, "DD/MM/YYYY") || "",
    cellRenderer: ({ data }) => getDate(data?.createdAt, "DD/MM/YYYY"),
    comparator: (a, b) => (a || 0) - (b || 0),
  },
  {
    headerName: "Statusi",
    field: "approved",
    flex: 3,
    mobile: true,
    isExported: true,
    filter: "agTextColumnFilter",
    valueGetter: ({ data }) => {
      if (data?.approved === true) {
        return "Aprovuar";
      } else {
        return "Pa Aprovuar";
      }
    },
    cellStyle: ({ data }) => {
      if (data?.approved === true) {
        return { backgroundColor: "rgba(29, 161, 147, 0.12)" };
      }
      if (data?.approved === false) {
        return { backgroundColor: "rgba(234, 57, 67, 0.10)" };
      }
      return { backgroundColor: "rgba(128, 128, 128, 0.08)" };
    },
    cellRenderer: ({ data }) => renderStatus(data?.approved),
  },
  {
    headerName: "Kohëzgjatja",
    field: "duration",
    flex: 2,
    isExported: true,
    filter: "agTextColumnFilter",
    mobile: true,
    valueGetter: ({ data }) => data?.duration,
  },
  {
    headerName: "Pushimi",
    field: "breakHours",
    flex: 2,
    mobile: true,
    isExported: true,
    filter: "agNumberColumnFilter",
    valueGetter: ({ data }) => data?.breakHours ?? 0,
    cellRenderer: ({ data }) => {
      const hours = data?.breakHours ?? 0;
      if (!hours) return "0";
      return `${hours}`;
    },
  },
  {
    headerName: "Pushim i paguar",
    field: "breakPaidLabel",
    flex: 2,
    mobile: true,
    isExported: true,
    hide: true,
    filter: "agSetColumnFilter",
    valueGetter: ({ data }) => data?.breakPaidLabel || "—",
  },
  {
    headerName: "Orët e punës",
    field: "workingHours",
    flex: 2,
    mobile: true,
    isExported: true,
    filter: "agNumberColumnFilter",
    valueGetter: ({ data }) => data?.workingHours ?? 0,
  },
  {
    headerName: "Orët e paguara",
    field: "paidHours",
    flex: 2,
    mobile: true,
    isExported: true,
    filter: "agNumberColumnFilter",
    valueGetter: ({ data }) => data?.paidHours ?? 0,
  },
  {
    headerName: "Lloji i turnit",
    field: "dayTypeLabel",
    mobile: true,
    flex: 3,
    isExported: true,
    filter: "agSetColumnFilter",
    filterParams: { applyMiniFilterWhileTyping: true },
    hide: false,
    valueGetter: ({ data = {} }) =>
      data.dayTypeLabel || dayTypes[data.dayType] || "",
    cellRenderer: ({ data = {} }) =>
      data.dayTypeLabel || dayTypes[data.dayType] || "",
  },
];

//region >renderStatus()
const renderStatus = (val) => {
  const statuses = {
    true: {
      background: "#E6F7F4",
      color: "#0F7A6E",
      border: "#9AD9D0",
      dot: "#1da193",
      label: "Aprovuar",
    },
    false: {
      background: "#FDECEE",
      color: "#C62828",
      border: "#F5B5BA",
      dot: "#ea3943",
      label: "Pa Aprovuar",
    },
    default: {
      background: "#F2F3F5",
      color: "#5F6368",
      border: "#D0D3D8",
      dot: "#8a8f98",
      label: "Pa Përcaktuar",
    },
  };

  const { background, color, border, dot, label } =
    statuses?.[val] || statuses.default;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        width: "100%",
      }}
    >
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          height: 24,
          padding: "0 10px",
          borderRadius: 999,
          background,
          color,
          border: `1px solid ${border}`,
          fontSize: 12,
          fontWeight: 600,
          lineHeight: 1,
          whiteSpace: "nowrap",
        }}
      >
        <span
          style={{
            width: 7,
            height: 7,
            borderRadius: "50%",
            background: dot,
            flexShrink: 0,
          }}
        />
        {label}
      </span>
    </div>
  );
};
